import { inject, Injectable } from '@angular/core';
import { BaseRequestService } from '@outlaw/core';
import { CommunityGroup, CommunityOwner } from '../../interfaces/community-owner';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { CommunityConfigService } from '../util';

@Injectable({ providedIn: 'root' })
export class OwnerService {
  private http = inject(HttpClient);
  private baseRequestService = inject(BaseRequestService);
  private communityConfigService = inject(CommunityConfigService);

  private ownerUrl = this.communityConfigService.internalApi.ownerUrl;
  private postUrl = this.communityConfigService.internalApi.postUrl;

  getOwnerByUUID(uuid: string): Observable<CommunityOwner> {
    return this.http.get<CommunityOwner>(this.baseRequestService.prepareUrl([this.ownerUrl, 'get_user', uuid]));
  }

  getOwnerByGroupId(groupId: string): Observable<CommunityGroup> {
    return this.http.get<CommunityGroup>(`${this.postUrl}/community-groups/${groupId}/`);
  }

  getUserByUsername(username: string): Observable<CommunityOwner> {
    return this.http.get<CommunityOwner>(
      this.baseRequestService.prepareUrl([this.ownerUrl, 'get_user_by_username', username])
    );
  }
}
